
const GTM_EVENTS = {
    changeColorModal: 'Change_Color_Overlay_Opened',
    changeVehicleCancel: 'Change_Vehicle_Cancel',
    changeVehicleUpdate:'Change_Vehicle_Update',
    collapseAll:'Collapse_All',
    expandAll: "Expand_All",
    colorChanged: 'Color_Changed',
    CTA: "CTA_Button",
    enlargeImagesView: "Enlarge_Images",
    exteriorFilterButton: "Exterior_Filter",
    interiorFilterButton: "Interior_Filter",
    featureSearch: "Feature_Search",
    printPdf: "Features_Print_PDF",
    filterSliderMax:"Filter_By_Price_Maximum",
    filterSliderMin:"Filter_By_Price_Minimum",
    filterSegmentVehicleSelected:"Filter_By_Vehicle_Type_Select",
    filterSegmentVehicleDeselected: "Filter_By_Vehicle_Type_Deselect",
    filterModelUpdated: "Filter_Models_Updated",
    filterModelCancelled:"Filter_Models_Cancelled",
    galleryScrollLeft: "Gallery_Scroll_Left",
    galleryScrollRight: "Gallery_Scroll_Right",
    gallerySelectView:"Gallery_View_Selected",
    featureBenefit: "Hyperlink_Feature_Overlay",
    newCompare: "New_Compare_Link",
    photos:"Photos",
    photosPrintPdf: "Photos_Print_PDF",
    removeVehicle: "Remove_Vehicle",
    selectSecondaryVehicle: "Select_Secondary_Vehicle_Started",
    selectVehicle: "Select_Vehicle",
    advantageChecked: "Show_Advantages_Only_Activated",
    advantagesUnchecked: "Show_Advantages_Only_Deactivated",
    vehicleModelSelected: "Vehicle_Model_Selected",
    vehicleModelYearSelected: "Vehicle_Model_Year_Selected",
    viewGallery: "View_Gallery",
    userEngagement: "user_engagement",
    pageView:"page_view",
    compareTrims: "Compare_Trims",
    compareCompetitors: "Compare_Competitors",
    changeVehiclePosition: "Change_Secondary_Vehicle_Position",
    vehicleLock:"Vehicle_Lock",
    viewSecondaryVehicleColors: "View_Secondary_Vehicle_Color",
};

function trackEventProps(event, props, eventProps) {
    const eventData = {
        event: event,
        Primary_Vehicle_Description: props?.primaryVehicleDescription,
        Secondary_Vehicle_One_Description: props?.secondaryOneVehicleDescription,
        Secondary_Vehicle_Two_Description: props?.secondaryTwoVehicleDescription,
        Secondary_Vehicle_Three_Description: props?.secondaryThreeVehicleDescription,
        Color: eventProps && eventProps?.colorProps ? eventProps.colorProps : (eventProps ? eventProps[0] :(props.color)),
        Primary_Vehicle_MSRP: props?.primaryVehicleMSRP,
        Secondary_Vehicle_One_MSRP: props?.secondaryOneVehicleMSRP,
        Secondary_Vehicle_Two_MSRP: props?.secondaryTwoVehicleMSRP,
        Secondary_Vehicle_Three_MSRP: props?.secondaryThreeVehicleMSRP,
        Tenant: props?.tenant,
        Language: props?.language,
        Primary_Vehicle_Year: props?.primaryVehicleYear,
        Primary_Vehicle_Model: props?.primaryVehicleModel,
        Primary_Vehicle_Trim: props?.primaryVehicleTrim,
        Primary_Vehicle_Make: props?.primaryVehicleMake
    };
    if (eventProps && eventProps.ctaID) {
        eventData.CTA_Text_Value = eventProps?.ctaID;
    }
    if (eventProps && eventProps.searchedFeature) {
        eventData.Feature_Search_Input_Value = eventProps?.searchedFeature;
    }
    !props?.errorCode && window.dataLayer?.push(eventData);

}

function trackBaseGroupEventProps(event, props, eventProps) {
    const eventData = {
        event: event,
        Tenant: props?.tenant,
        Language: eventProps && eventProps?.language ? eventProps?.language : (props && props?.language)
    };
    window.dataLayer?.push(eventData);
}

function trackFilterGroupEventProps(event, props) {
    window.dataLayer.push({
        event: event,
        Filter_By_Price_Maximum: props?.maximumPrice,
        Filter_By_Price_Minimum: props?.minimumPrice,
        Tenant: props.tenant,
        Language: props.language,
    });
}


function trackChangeColorModalEvent(props, colorProps) {
    trackEventProps(GTM_EVENTS.changeColorModal, props, colorProps)
    }

function trackChangeUpdateVehicle(props) {
    trackEventProps(GTM_EVENTS.changeVehicleUpdate, props)
}

function trackChangeVehicleCancel(props){
    trackEventProps(GTM_EVENTS.changeVehicleCancel, props)
   }

function trackCollapseAllHandler(props){
    trackEventProps(GTM_EVENTS.collapseAll, props)

}

function trackExpandAllHandler(props){
    trackEventProps(GTM_EVENTS.expandAll, props)
}

function trackColorChanged(props, colorProps){
    trackEventProps(GTM_EVENTS.colorChanged, props, {colorProps})
}

function trackCTAButtons(props, ctaID){
    trackEventProps(GTM_EVENTS.CTA, props, {ctaID})
    }

function trackEnlargeViewHandler(props){
    trackEventProps(GTM_EVENTS.enlargeImagesView, props)
}

function trackExteriorFilterButton(props){
    trackEventProps(GTM_EVENTS.exteriorFilterButton, props)
}

function trackInteriorFilterButton(props){
    trackEventProps(GTM_EVENTS.interiorFilterButton, props)
   }

function trackFeatureSearchInput(props, searchedFeature){
    trackEventProps(GTM_EVENTS.featureSearch, props, {searchedFeature})
   }

function trackPrintPDF(props){
    trackEventProps(GTM_EVENTS.printPdf, props)
    }


function trackPriceRangeSliderMin(props) {
    trackBaseGroupEventProps(GTM_EVENTS.filterSliderMin, props);
}

function trackPriceRangeSliderMax(props) {
    trackBaseGroupEventProps(GTM_EVENTS.filterSliderMax, props);
}

function trackVehicleSegmentSelected(props) {
    trackBaseGroupEventProps(GTM_EVENTS.filterSegmentVehicleSelected, props);
}

function trackVehicleSegmentDeselected(props) {
    trackBaseGroupEventProps(GTM_EVENTS.filterSegmentVehicleDeselected, props);
}

function trackVehicleModelsUpdated(props){
    trackFilterGroupEventProps(GTM_EVENTS.filterModelUpdated, props);
}

function trackVehicleModelsCancelled(props){
    trackFilterGroupEventProps(GTM_EVENTS.filterModelCancelled, props);
}

function trackGalleryScrollRight(props){
    trackEventProps(GTM_EVENTS.galleryScrollRight, props)
    }

function trackGalleryScrollLeft(props){
    trackEventProps(GTM_EVENTS.galleryScrollLeft, props)
    }

function trackGalleryViewSelected(props){
    trackEventProps(GTM_EVENTS.gallerySelectView, props)
    }

function trackFeatureBenefitHyperLink(props){
    trackEventProps(GTM_EVENTS.featureBenefit, props)
   }

function trackNavigateToNewCompare(props){
    trackEventProps(GTM_EVENTS.newCompare, props)
    }

function trackNavigateToPhotos(props){
    trackEventProps(GTM_EVENTS.photos, props)
    }

function trackPhotosPDF(props){
    trackEventProps(GTM_EVENTS.photosPrintPdf, props)
}

function trackRemovedVehicle(props){
    trackEventProps(GTM_EVENTS.removeVehicle, props)
}

function trackSelectSecondaryVehicle(props){
    trackEventProps(GTM_EVENTS.selectSecondaryVehicle, props)
    }

function trackAdvantagesChecked(props){
    trackEventProps(GTM_EVENTS.advantageChecked, props)
}

function trackAdvantagesUnChecked(props){
    trackEventProps(GTM_EVENTS.advantagesUnchecked, props)
}

function trackViewGallery(props){
    trackEventProps(GTM_EVENTS.viewGallery, props)
   }

function trackVehicleModelYearSelected(props){
    trackBaseGroupEventProps(GTM_EVENTS.vehicleModelYearSelected, props);
}

function trackUserEngagement(props,language){
    trackBaseGroupEventProps(GTM_EVENTS.userEngagement, props, {language})
}

function trackPageViewEngagement(props, language){
    trackBaseGroupEventProps(GTM_EVENTS.pageView, props, {language})
}


function trackSelectVehicle(props,data){
    window.dataLayer.push({
        event: GTM_EVENTS.selectVehicle,
        Selected_Vehicle_Code: props?.code,
        Selected_Vehicle_MSRP: props?.pricing.msrp,
        Selected_Vehicle_Trim: props?.trim,
        Tenant: data?.tenant,
        Language: data?.language,
    });
}

function trackVehicleModelSelected(props,pricing){
    window.dataLayer.push({
        event: GTM_EVENTS.vehicleModelSelected,
        Tenant: props?.tenant,
        Language: props?.language,
        Vehicle_Model_Selected_Minimum_MSRP: pricing.minMsrp,
        Vehicle_Model_Selected_Maximum_MSRP: pricing.maxMsrp

    });
}

function trackVehiclePositionChanged(props) {
    trackEventProps(GTM_EVENTS.changeVehiclePosition, props)
}

function trackVehicleLock(props) {
    trackEventProps(GTM_EVENTS.vehicleLock, props)
}

function trackViewSecondaryVehicleColors(props) {
    trackEventProps(GTM_EVENTS.viewSecondaryVehicleColors, props)
}

function trackCompareCompetitors(props) {
    trackEventProps(GTM_EVENTS.compareCompetitors, props);
}


function trackCompareTrims(props) {
    trackEventProps(GTM_EVENTS.compareTrims, props);
}


export {  trackChangeColorModalEvent, trackChangeUpdateVehicle, trackChangeVehicleCancel, trackCollapseAllHandler,
    trackExpandAllHandler, trackColorChanged, trackCTAButtons, trackEnlargeViewHandler,
    trackExteriorFilterButton , trackInteriorFilterButton, trackFeatureSearchInput, trackPrintPDF, trackPriceRangeSliderMin,trackPriceRangeSliderMax,
    trackVehicleSegmentSelected , trackVehicleSegmentDeselected, trackVehicleModelsUpdated, trackVehicleModelsCancelled, trackGalleryScrollRight,
    trackGalleryScrollLeft, trackGalleryViewSelected, trackFeatureBenefitHyperLink, trackNavigateToNewCompare, trackNavigateToPhotos , trackPhotosPDF,
    trackRemovedVehicle, trackSelectSecondaryVehicle, trackSelectVehicle, trackAdvantagesUnChecked, trackAdvantagesChecked,
    trackViewGallery, trackVehicleModelYearSelected,trackVehicleModelSelected,trackUserEngagement,trackPageViewEngagement, trackVehiclePositionChanged,
    trackVehicleLock, trackViewSecondaryVehicleColors, trackCompareTrims, trackCompareCompetitors };
